import { ArgumentError } from '../utils/errors';

import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class ResaleConfigModel extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true },
            organization: {},
            event: {},
            rate: {},
            group: {},
            enabled: {}
        };
    }

    static listUrl({ organizationId }) {
        if (!organizationId) {
            throw new ArgumentError(`[Model][RateModel][getAll] organizationId is mandatory`);
        }

        return `/ticket/organizations/${organizationId}/resale/config`;
    }
}
